import { css } from "lit";

export const tabBarStyles = css`
  :host {
    display: block;
  }

  .tab-bar {
    display: flex;
    gap: var(--tab-bar-gap, var(--sds-size-space-800));
    border-bottom: 1px solid var(--tab-bar-border-color, var(--sds-color-border-default-default));
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .tab-button {
    position: relative;
    padding: 12px 0;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font: var(
      --tab-bar-font,
      var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body)
    );
    color: var(--tab-bar-color, var(--sds-color-text-default-tertiary));
    transition:
      color 0.2s ease,
      border-color 0.2s ease;
    white-space: nowrap;
    opacity: 0.7;
  }

  .tab-button:hover:not(:disabled) {
    color: var(--tab-bar-hover-color, var(--sds-color-text-default-secondary));
    opacity: 1;
  }

  .tab-button.active {
    color: var(--tab-bar-active-color, var(--sds-color-text-default-default));
    border-bottom-color: var(--tab-bar-active-border-color, var(--sds-color-text-default-default));
    opacity: 1;
  }

  .tab-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .tab-badge {
    position: absolute;
    top: 4px;
    right: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 1px;
    border-radius: 50%;
    background: var(--tab-bar-badge-color, var(--sds-color-background-danger-default));
    color: #fff;
    font-size: 10px;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
  }
`;
